export * from './incident-table.component';
